import { useEffect, useState } from 'react';

export const useDropdownAutoClose = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (event: MouseEvent) => {
      if (!dropdownOpen) {
        return;
      }

      if (
        event.clientY <= 0 ||
        event.clientX <= 0 ||
        event.clientX >= window.innerWidth ||
        event.clientY >= window.innerHeight
      ) {
        setDropdownOpen(false);
      }
    };

    const handleWindowBlur = () => {
      if (dropdownOpen) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mouseout', handleMouseLeave);
    window.addEventListener('blur', handleWindowBlur);

    return () => {
      document.removeEventListener('mouseout', handleMouseLeave);
      window.removeEventListener('blur', handleWindowBlur);
    };
  }, [dropdownOpen, setDropdownOpen]);

  return {
    dropdownOpen,
    setDropdownOpen,
  };
};
